import React from "react";

// Always renders the brand name in glossy gold. Use everywhere "Smokey & Creamy" appears.
export const BrandName = ({ className = "", as: Tag = "span" }) => (
  <Tag className={`text-gold-gloss font-display ${className}`}>Smokey &amp; Creamy</Tag>
);

export default BrandName;
